import { api } from "@/api"
import type { RetrieveNextNotificationResponse } from "./retrieveNextNotification"

export const viewNotification = async (
  notificationId: RetrieveNextNotificationResponse["id"]
) => {
  api.post(`/notifications/${notificationId}/view/`)
}
